import * as React from 'react'
import cx from 'classnames'
import Icon from '../../../components/Icon'
import styles from './TableSearchbar.sass'

interface TableSearchbarProps {
  searchText: string
  disabled?: boolean
  onSearchTextChange: (value: string) => void
  children?: React.ReactNode
  placeholder?: string
}

/**
 * The TableSearchbar.
 */
export function TableSearchbar({
  searchText,
  disabled,
  children,
  onSearchTextChange,
  placeholder,
}: TableSearchbarProps) {
  const change = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) =>
      onSearchTextChange(e.target.value),
    [onSearchTextChange],
  )
  return (
    <div className={cx(styles.root)}>
      <div className={styles.mainMenu}>
        <div className={styles.searchInputContainer}>
          <div className={styles.searchInputIcon}>
            <Icon name="search" />
          </div>
          <input
            className={styles.searchInput}
            placeholder={placeholder ?? 'Search'}
            type="search"
            autoComplete="off"
            autoCapitalize="off"
            autoCorrect="off"
            value={searchText}
            onChange={change}
            disabled={disabled}
          />
        </div>
        <div className={styles.menuItems}>{children}</div>
      </div>
    </div>
  )
}

interface TableSearchbarMenuItemProps {
  children?: React.ReactNode
}

/**
 * Table Searchbar Menu Item
 */
export function TableSearchbarMenuItem({
  children,
}: TableSearchbarMenuItemProps) {
  return <div className={styles.menuItem}>{children}</div>
}
